import React from 'react';
import { browserHistory } from 'react-router';
import { Col, Button, Input, Modal } from 'angieslist-react-components';
import { hot } from 'react-hot-loader';
import { get } from 'lodash';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { analytics, Track } from 'angieslist-app-platform';
import classNames from 'classnames';
import urlCatalog from '@angi/url-catalog';
import type { BusinessListReducerState } from '../common/businessListReducer';
import { WarningIcon, ExclamatoryIcon } from '../modules/browser/home/common/Icons';
import serviceProviderActions from '../../../app/common/serviceProvider/serviceProviderActions';
import NotificationService from '../modules/browser/home/common/NotificationService';
import './LinkABusiness.scss';
import accountSyncActions from '../../sync/common/accountSyncActions';
import linkABusinessAnalytics from './linkABusinessAnalytics';


export type LinkBusinessPageProps = {
  accountSync: any,
  linkBusinessResponse: BusinessListReducerState,
  linkBusiness: typeof accountSyncActions.linkBusiness,
  experiment: Object
}

const errCodes = [403];

export class LinkBusinessPage extends React.Component<LinkBusinessPageProps> {
  // eslint-disable-next-line react/sort-comp
  notify: NotificationService;

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      show: false,
      modal: false,
      pwdFocus: false,
      emailFocus: false,
      showError: false,
    };
    this.notify = new NotificationService();
  }

  componentWillReceiveProps(nextProps) {
    const {
      accountSync: {
        linkBusiness: {
          error,
          isLoading,
        },
      },
    } = nextProps;
    const {
      email,
      password,
    } = this.state;

    if (isLoading || email === '' || password === '') return;
    if (error) {
      if (errCodes.includes(error.status)) {
        this.setState({ modal: true });
      } else {
        this.setState({ modal: true });
      }
    } else {
      setTimeout(() => {
        browserHistory.push('/app/home');
      }, 1);
    }
  }

  onBackClicked = () => {
    setTimeout(() => {
      browserHistory.push('/app/home');
    }, 1);
  };

  getEmailHint = () => {
    const {
      email,
      emailFocus,
    } = this.state;
    return ((email.length === 0 && emailFocus) ? 'Enter Leads email or username.' : '');
  };

  getInputProps = (type) => {
    const {
      email,
      password,
    } = this.state;
    if ((type === 'email' && email.length > 0) || (type === 'pwd' && password.length > 0)) {
      return { label: type === 'email' ? 'Leads email or username' : 'Leads password' };
    }
    return null;
  };

  getPwdHint = () => {
    const {
      password,
      pwdFocus,
    } = this.state;
    return ((password.length === 0 && pwdFocus) ? 'Enter your Leads password.' : '');
  };

  handleLinkBusiness = () => {
    const { linkBusiness } = this.props;
    const {
      email,
      password,
    } = this.state;
    linkBusiness(email, password);
    this.setState({ showError: false });
  };

  handleModalClose = () => this.setState({ modal: false });

  validateEmail = () => {
    const {
      email,
      emailFocus,
    } = this.state;
    return (email.length === 0 && emailFocus ? 'error' : null);
  };

  handleEmailChange = e => this.setState({ email: e.target.value });

  validatePassword = () => {
    const {
      password,
      pwdFocus,
    } = this.state;
    return (password.length === 0 && pwdFocus ? 'error' : null);
  };

  handlePwdChange = e => this.setState({ password: e.target.value });

  toggleShow = () => {
    this.setState((prevState, __props) => ({ show: !prevState.show }));
  };

  isBtnDisabled = () => {
    const {
      email,
      password,
    } = this.state;
    if (email.length === 0 || password.length === 0) {
      return true;
    }
    return false;
  };

  render() {
    const {
      accountSync: {
        linkBusiness: {
          isLoading,
        },
      },
      experiment = {},
    } = this.props;
    const {
      email,
      password,
      show,
      modal,
      showError,
    } = this.state;

    const linkABusinessEnabled = get(experiment, 'experiments.linkBusiness.enabled', false);
    if (!linkABusinessEnabled) {
      return (
        browserHistory.push('/app/home')
      );
    }

    return (
      <Col xs={12} md={6} mdOffset={3} lg={4} lgOffset={4} sm={8} smOffset={2}>
        <Track>
          <div id="link-a-business">
            <Track>
              <div className="back-btn" id="back-to-list-btn" role="button" tabIndex={0} onClick={this.onBackClicked} onKeyDown={this.onBackClicked}>
                <i className="icon icon-left" /> Back
              </div>
            </Track>
            <div>
              {showError &&
                <div className="error">
                  <ExclamatoryIcon />
                  <div className="error-msg">
                    Leads email, username or password is not correct. Or, need to&nbsp;
                    <Track>
                      <a
                        className="angi-ads-link-page"
                        id="error-message-help"
                        href={urlCatalog.office.intercomLinkAdsBusinessHelp()}
                        target="_blank"
                      >
                        link an Angi Ads (Angie’s List) business?
                      </a>
                    </Track>
                  </div>
                </div>}
            </div>
            <div className="login-info">
              <div className="h1 link-business-info">Let’s verify the Leads business you’re linking.</div>
              <div className="link-business-subcopy">By linking your Angi Leads business you can access all of your Angi accounts with one username and password.</div>
              <div className={classNames('input-container', { showLabel: email.length > 0 })}>
                <form autoComplete="on">
                  <Input
                    className="email"
                    id="login-email"
                    type="text"
                    bsStyle={this.validateEmail()}
                    onChange={this.handleEmailChange}
                    {...this.getInputProps('email')}
                    placeholder="Leads email or username"
                    help={this.getEmailHint()}
                    onBlur={() => { this.setState({ emailFocus: true }); }}
                  />
                </form>
              </div>
              <div className={classNames('input-container', { showLabel: password.length > 0 })}>
                <Input
                  className="pwd"
                  id="login-password"
                  autoComplete="off"
                  type={show ? 'text' : 'password'}
                  bsStyle={this.validatePassword()}
                  onChange={this.handlePwdChange}
                  {...this.getInputProps('pwd')}
                  addonAfter={
                    <Button className="show-btn" id="show-btn" onClick={this.toggleShow}>
                      { show ? 'Hide' : 'Show' }
                    </Button>}
                  placeholder="Leads password"
                  help={this.getPwdHint()}
                  onBlur={() => { this.setState({ pwdFocus: true }); }}
                />
              </div>
              <Modal show={modal} onHide={this.handleModalClose}>
                <div className="pop-up-close">
                  <Modal.Header closeButton />
                </div>
                <div className="pop-up-body">
                  <Modal.Body>
                    <div className="pop-up-error">
                      <WarningIcon />
                      <h3>We are unable to link this business</h3>
                      <div className="retry-msg"> Retry linking your business later, or&nbsp;
                        <Track>
                          <a
                            className="help-contact"
                            href={urlCatalog.global.customerCarePhone()}
                            id="phone"
                          >
                            call {urlCatalog.global.customerCarePhoneText()}
                          </a>
                        </Track> for assistance.
                      </div>
                      <div className="help-info">
                        <p>Need to link an Angi Ads (Angie’s List) business?</p>
                        <div>
                          <Track>
                            <a
                              className="get-help"
                              id="help"
                              href={urlCatalog.office.intercomLinkAdsBusinessHelp()}
                              target="_blank"
                            >
                              Get help.
                            </a>
                          </Track>

                        </div>
                      </div>
                      <Button
                        id="pop-up-back-btn"
                        className="pop-up-link-btn"
                        type="submit"
                        onClick={this.onBackClicked}
                      >
                        Back to business list
                      </Button>
                    </div>
                  </Modal.Body>
                </div>
              </Modal>
              <Track>
                <a className="forgot-info" href={urlCatalog.office.leads.legacy.forgotUsernameOrPassword()} id="forgot-info-link" target="_blank">Forgot username or password?</a>
              </Track>
              <div> Need help?&nbsp;
                <Track>
                  <a
                    className="help-contact"
                    href={urlCatalog.global.customerCarePhone()}
                    id="phone"
                  >
                    Call {urlCatalog.global.customerCarePhoneText()}
                  </a>
                </Track>
              </div>
              <Button
                id="link-btn-clicked"
                className="link-btn"
                bsStyle="primary-office"
                type="submit"
                onClick={this.handleLinkBusiness}
                disabled={this.isBtnDisabled() || isLoading}
              >
                Link my Angi Leads business
              </Button>
              <div className="help-info">
                Trying to add an Angi Ads (Angie’s List) business?&nbsp;
                <Track>
                  <a
                    className="get-help"
                    id="help"
                    href={urlCatalog.office.intercomLinkAdsBusinessHelp()}
                    target="_blank"
                  >
                    Get help.
                  </a>
                </Track>
              </div>
            </div>
          </div>
        </Track>
      </Col>
    );
  }
}


export default (hot(module)(compose(
  analytics({
    ruleset: linkABusinessAnalytics,
  }),
  connect(
    state => ({
      linkBusinessResponse: state.businessList,
      accountSync: state.accountSync,
      serviceProviderCache: state.serviceProviderCache,
      experiment: state.experimentV2,
    }),
    {
      ...accountSyncActions,
      ...serviceProviderActions,
    },
  ),
  pure,
)(LinkBusinessPage)): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/LinkABusiness.js